export default [
  {
    path: "/positions",
    name: "positions",
    meta: {
      title: "新发职位",
      requireAuth: true
    },
    component: () => import("./list.vue")
  },
  {
    path: "/positions/detail/:positionId",
    name: "detail",
    meta: {
      title: "职位详情",
      requireAuth: true
    },
    component: () => import("./detail.vue")
  },

  {
    path: "/positions/detail-portrait/:positionId",
    name: "detail-portrait",
    meta: {
      title: "职位详情",
      requireAuth: true
    },
    component: () => import("./detail-portrait.vue")
  },
  {
    path: "/portraitLens/:positionId",
    name: "portraitLens",
    meta: {
      title: "目标人选画像透镜"
    },
    component: () => import("./portraitLens.vue")
  }
];




